import { render, staticRenderFns } from "./SftpBulkUpload.vue?vue&type=template&id=357cc55c&"
import script from "./SftpBulkUpload.vue?vue&type=script&lang=js&"
export * from "./SftpBulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./SftpBulkUpload.vue?vue&type=style&index=0&id=357cc55c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports